import router from './router'
import store from './store'
import {getToken} from '@/utils/auth'

const whiteList = ["/login","/register","/changePsd"]; // 不重定向白名单
router.beforeEach((to, from, next) => {
  if (getToken()) {//如果有token
    if (to.path === '/login') {
      next('/')
    }else if (to.path === '/404') {
      next()
    } else {
      if (!store.getters.username) {
        store.dispatch('GetInfo').then(res => { // 拉取用户信息
          next({...to,replace:true})
        }).catch(() => {
          store.dispatch('FedLogOut').then(() => {
            next({path: '/login'})
          })
        });
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
    }
  }
});
router.onError((error) => {
  console.log(error,'err被捕获');
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  try {
    if (isChunkLoadFailed) {
      let LoadingChunk = window.sessionStorage.getItem('LoadingChunk');
      if (LoadingChunk) {
        window.sessionStorage.setItem('LoadingChunk', LoadingChunk - 0 + 1);
      } else {
        window.sessionStorage.setItem('LoadingChunk', 1);
      }
      if (LoadingChunk - 0 > 1) {
        // 防止 死循环
        return false;
      }
      router.replace(targetPath);
      window.sessionStorage.setItem('LoadingChunkPath', targetPath);
      const sa = window.sa;
      if (sa && sa.track) {
        sa.track('element_click', {
          page_title: 'LoadingChunk',
          element_type: 'view',
          page_source: targetPath, // 当前路由
          element_name: `刷新页面${LoadingChunk - 0}次` // 尝试 打开次数
        });
      }

    }
  } catch (e) {
    console.log(e);
  }
});
router.onReady(vm => {
  console.log(vm,'routeronready');
  try {
    let LoadingChunkPath = window.sessionStorage.getItem('LoadingChunkPath');

    const path = vm.path;
    if (LoadingChunkPath) {
      if (path !== LoadingChunkPath && path !== '/') {
        window.sessionStorage.setItem('LoadingChunkPath', vm.path);
        router.replace(vm.path);
      } else {
        router.replace(LoadingChunkPath);
      }
    }
  } catch (e) {
    console.log(e);
  }
});



// WEBPACK FOOTER //
// ./src/permission.js